import { useState, useEffect } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { getAllTemplates } from '../api'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
}

export const useGetAllTemplatesOnMount = (props: Props) => {
  const { entityId, entityType } = props
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(
          getAllTemplates({
            proposalEntityId: entityId,
            proposalEntityType: entityType,
          }),
        )

        if (mounted) {
          if (getAllTemplates.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error('Error loading proposal templates.')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, entityId, entityType])

  return status
}
